export enum FileProviderData {
  fileProvider = 'file-provider-data',
  fileProviderMemory = 'file-provider-memory',
}
